import properties from "refractor/properties";
export default properties;